module.exports = __webpack_public_path__ + "files/hemato.aa5c177bdecd4156743bda3909df83fd.pdf";